import Http from '@/api/http.js'

export default {

  index(params) {
    // let search = ''
    // const {limit, page, level} = filter
    // search = `_page=${page}&_limit=${limit || 1000}&attributes.level=${level}`

    return Http.get(`/bank_accounts`,{params})
  },

  indexByModel({model, id}) {
    return Http.get(`${model}/${id}/bank_accounts`)
  },

  create(bank_account){
    return Http.post(`/bank_accounts`, {bank_account: {...bank_account}})
  },

  update(bank_account){
    return Http.put(`/bank_accounts/${bank_account.id}`, {
      bank_account: {...bank_account},
    });
  },

  show(id) {
    return Http.get(`/bank_accounts/${id}`);
  },

  delete(id){
    return Http.delete(`/bank_accounts/${id}`)
  }

}
